import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import AuthService from '../../services/AuthService';
import { MemberLinkBtnBlue } from '../../styles/Elements';

export default class UserDetail extends Component {
    
    state = {
        oneUser: [],
        roles : [],
        authentications :{
            admin:false,
            mod:false,
            bish:false,
            urltoken:'',
            user:false
        }

        
    };

    componentDidMount() {
      this.refreshUserDetails();
    }

    refreshUserDetails = () => {
        const { match: { params } } = this.props;
        const userName = params.username;
        AuthService.getOneUserbyUserName(userName)
            .then(res => {
             const oneUser = res.data;
             this.setState({oneUser : oneUser,
                roles : oneUser.roles}
            ) 

            })
    }

    enableUser(userName) {
        AuthService.enableUser(userName)
        .then((res) => {
            this.refreshUserDetails();
            window.location.reload();
        })
        .catch((err) => {
        });
    }

    disableUser(userName) {
        AuthService.disableUser(userName)
        .then((res) => {
            this.refreshUserDetails();
            window.location.reload();
        })
        .catch((err) => {
        });
    }


            ActivateBish(userName) {
            AuthService.ActivateBish(userName)
            .then((res) => {
                this.refreshUserDetails();
                window.location.reload();
            })
            .catch((err) => {
            });
        }

        deActivateBish(userName) {
            AuthService.deActivateBish(userName)
            .then((res) => {
                this.refreshUserDetails();
                window.location.reload();
            })
            .catch((err) => {
            });
        }

        ActivateModerator(userName) {
            AuthService.ActivateModerator(userName)
            .then((res) => {
                this.refreshUserDetails();
                window.location.reload();
            })
            .catch((err) => {
            });
        }

        deActivateModerator(userName) {
            AuthService.deActivateModerator(userName)
            .then((res) => {
                this.refreshUserDetails();
                window.location.reload();
            })
            .catch((err) => {
            });
        }


        unlockSMSBish(userName) {
            AuthService.unlockSMSForUser(userName)
            .then((res) => {
                this.refreshUserDetails();
                window.location.reload();
            })
            .catch((err) => {
                window.location.reload();
            });
        }
        

        getActivationLinkForUser(userName) {
            AuthService.getActivationLinkForUser(userName)
            .then(res => {
                const urltoken = res.data;
                this.setState({urltoken : urltoken});
                alert(urltoken);
            }).catch((err) =>{
                alert("Unable To get URL : " + err)
            })
        }
    


    render() {  
        return (
            <div className="viewMain">
                <div className="view-details">
                    <div className="card-details" key={this.state.oneUser.id} >
                      


                        <div className="card-group-field" key={this.state.oneUser.id}>
                            <h4> ID </h4>
                            <h5> {this.state.oneUser.id}</h5>
                        </div>

                        <div className="card-group-field" key={this.state.oneUser.name}>
                            <h4> Name </h4>
                            <h5> {this.state.oneUser.name}</h5>
                        </div>

                        <div className="card-group-field">
                            <h4> username   </h4>
                            <h5> {this.state.oneUser.username}  </h5>
                        </div>


                        <div className="card-group-field">
                            <h4> Email   </h4>
                            <h5> {this.state.oneUser.email}  </h5>
                        </div>

                        <div className="card-group-field">
                            <h4> Phone Number   </h4>
                            <h5> {this.state.oneUser.phoneNumber ? this.state.oneUser.phoneNumber : "Not Available" }  </h5>
                        </div>

                        <div className="card-group-field">
                            <h4> Request Permission  </h4>
                            <h5> {this.state.oneUser.requestPermission  ? " True " : " False "}   </h5>
                        </div>

                        <div className="card-group-field">
                            <h4> SMS Locked ?   </h4>
                            <h5> {this.state.oneUser.numberOfSendSMS > 3  ? 
                             <button   onClick={() => { if (window.confirm('Are you sure you want to UNLOCK SMS for this user')) this.unlockSMSBish(this.state.oneUser.username)}} 
                             className="activate-bish"> Unlock SMS </button>
                            :  "False"}   </h5>
                        </div>


                        <div className="card-group-field">
                            <h4> Activation URL Token   </h4>
                             <button  className="activate-bish"   onClick={() => {this.getActivationLinkForUser(this.state.oneUser.username)}}>Show URL</button>
                        </div>


                        {/* <div className="card-group-field">
                            <h4> Active </h4>
                            <h4> {this.state.oneUser.allowed ? "Active" : "Not Active"}  </h4>
                        </div> */}

                       <div className="card-group-field">
                            <h4> Roles   </h4>
                            {this.state.roles.map(role => (
                            <h5 key={role.id}>{role.name === "ROLE_ADMIN" ? " | Admin |" : 
                            role.name === "ROLE_BISH" ? "| Bish | " :
                            role.name === "ROLE_MODERATOR" ? "| Moderator |" :
                            role.name === "ROLE_USER" ? " | User |" :
                            null
                            }</h5>
                           
                              
                               ))}
                               </div>

                               <div className="card-group-field">
                            <h4> Control Roles   </h4>

                                            <button   onClick={() => { if (window.confirm('Are you sure you want to add Bish Authentication for this user')) this.ActivateBish(this.state.oneUser.username)}} 
                                            className="activate-bish">Bish</button>
                                            <button onClick={() => { if (window.confirm('Are you sure you want to remove Bish Authentication for this user')) this.deActivateBish(this.state.oneUser.username)}} 
                                            className="deactivate-bish">Bish</button>
     
                                            <button onClick={() => { if (window.confirm('Are you sure you want to add Moderator Authentication for this user')) this.ActivateModerator(this.state.oneUser.username)}} 
                                            className="activate-moderator">Moderator</button>
                                             <button onClick={() => { if (window.confirm('Are you sure you want to remove Moderator Authentication for this user')) this.deActivateModerator(this.state.oneUser.username)}} 
                                            className="deactivate-moderator">Moderator</button>
                                           </div>




                         <div className="card-group-field">
                            <h4> Active ?    </h4>
                           {this.state.oneUser.allowed ? 
                           <div>
                            <h5>User is Active </h5>
                            <button onClick={() => { if (window.confirm('Are you sure you want to -Disable- this user')) this.disableUser(this.state.oneUser.username)}} 
                           className ="deactivate-bish"> Disable</button>
                           </div>
                       : 
                       <div>
                       <h5>User is NOT Active </h5>
                       <button onClick={() => { if (window.confirm('Are you sure you want to -Enable- this user')) this.enableUser(this.state.oneUser.username)}}  
                      className ="activate-moderator">Enable</button>
                      </div>}
                      </div>
                               <MemberLinkBtnBlue to='/adminboard/'> Back to Admin Board </MemberLinkBtnBlue>
                              </div>
                 
                    </div>
                 
                </div>
                
            
            
          
        )
    }
}
